package ai.jessie.web.customers

import ai.jessie.web.onboarding.HTTP_CONFLICT
import ai.jessie.web.onboarding.OnboardingProblem
import ai.jessie.web.onboarding.OnboardingRequestFailure
import ai.jessie.web.onboarding.problem

// UC-012 outcomes. Everything else keeps the UC-006 tenant-denial presentation unchanged.
internal fun CustomerRequestFailure.customerProblem(): OnboardingProblem =
    when {
        // A11: no record detail, only the neutral absence.
        status == HTTP_NOT_FOUND -> unavailableCustomerProblem()
        detail.code == "STALE_CUSTOMER" ->
            OnboardingProblem(
                "Der Kunde wurde inzwischen geändert. Es wurde nichts gespeichert. Bitte lade den " +
                    "aktuellen Stand und trage gewünschte Änderungen erneut ein."
            )
        detail.code == "DUPLICATE_CONFIRMATION_REQUIRED" ->
            OnboardingProblem(
                "Inzwischen gibt es mögliche Dubletten. Es wurde nichts gespeichert. Bitte prüfe " +
                    "die Liste und bestätige, dass der Kunde eigenständig ist."
            )
        detail.code == "CUSTOMER_TYPE_REFERENCED" ->
            OnboardingProblem("$TYPE_REFERENCED Es wurde nichts gespeichert.", listOf(TYPE_ID))
        detail.code == "CUSTOMER_TYPE_CHANGE_UNAVAILABLE" ->
            OnboardingProblem("$TYPE_UNAVAILABLE Es wurde nichts gespeichert.", listOf(TYPE_ID))
        status == HTTP_CONFLICT ->
            OnboardingProblem("Der Kunde kann nicht geändert werden. Es wurde nichts gespeichert.")
        else -> OnboardingRequestFailure(status, detail.code, detail.fields).problem()
    }

internal fun unavailableCustomerProblem() =
    OnboardingProblem("Nicht verfügbar oder du hast keinen Zugriff.")

internal fun customerValidationProblem(problems: Map<String, String>) =
    OnboardingProblem(
        "Bitte korrigiere die markierten Felder. Es wurde nichts gespeichert.",
        problems.keys.map { "customer-$it" },
    )

internal fun uncertainCustomerProblem() =
    OnboardingProblem(
        "Die Antwort konnte nicht bestätigt werden. Bitte brich die Bearbeitung ab und lade neu, " +
            "um den gespeicherten Stand zu prüfen."
    )

// A5, BR-070: a referenced customer is archived and replaced.
internal const val TYPE_REFERENCED =
    "Der Kundentyp kann nicht geändert werden, weil Projekte auf diesen Kunden verweisen. " +
        "Archiviere den Kunden und erfasse einen neuen."

// B3: unavailable proof of absence is not a statement that no linked records exist.
internal const val TYPE_UNAVAILABLE =
    "Der Kundentyp kann zurzeit nicht geändert werden, weil Verknüpfungen nicht vollständig " +
        "geprüft werden können. Archiviere den Kunden bei Bedarf und erfasse einen neuen."

internal const val TYPE_ID = "customer-type"
private const val HTTP_NOT_FOUND = 404
